// Excel template configurations for different view types

export const EXPORT_TEMPLATES = {
  category: {
    name: 'Category Forecast',
    description: 'Monthly forecast data grouped by category',
    columns: [
      { key: 'name', label: 'Category', width: 20, type: 'text' },
      { key: 'currentStock', label: 'Current Stock', width: 15, type: 'number' },
      { key: 'calculatedMonthCover', label: 'Month Cover', width: 15, type: 'monthCover' },
      { key: 'inventoryStatus', label: 'Status', width: 15, type: 'status' }
    ],
    monthlyColumns: [
      { suffix: '_forecast', label: 'Forecast', width: 15, type: 'number' },
      { suffix: '_actual', label: 'Actual', width: 15, type: 'actualNumber' },
      { suffix: '_accuracy', label: 'Accuracy', width: 15, type: 'percentage' },
      { suffix: '_upcoming', label: 'Upcoming', width: 15, type: 'number' }
    ]
  },

  product: {
    name: 'Product Forecast',
    description: 'Monthly forecast data grouped by product',
    columns: [
      { key: 'productName', label: 'Product Name', width: 30, type: 'text', fallback: 'name' },
      { key: 'category', label: 'Category', width: 20, type: 'text' },
      { key: 'currentStock', label: 'Current Stock', width: 15, type: 'number' },
      { key: 'calculatedMonthCover', label: 'Month Cover', width: 15, type: 'monthCover' },
      { key: 'inventoryStatus', label: 'Status', width: 15, type: 'status' }
    ],
    monthlyColumns: [
      { suffix: '_forecast', label: 'Forecast', width: 15, type: 'number' },
      { suffix: '_actual', label: 'Actual', width: 15, type: 'actualNumber' },
      { suffix: '_accuracy', label: 'Accuracy', width: 15, type: 'percentage' },
      { suffix: '_upcoming', label: 'Upcoming', width: 15, type: 'number' }
    ]
  },

  sku: {
    name: 'SKU Forecast',
    description: 'Detailed monthly forecast data by SKU with comprehensive tracking',
    columns: [
      { key: 'sku', label: 'SKU', width: 20, type: 'text' },
      { key: 'productName', label: 'Product Name', width: 30, type: 'text' },
      { key: 'category', label: 'Category', width: 20, type: 'text' },
      { key: 'currentStock', label: 'Current Stock', width: 15, type: 'number' },
      { key: 'calculatedMonthCover', label: 'Month Cover', width: 15, type: 'monthCover' },
      { key: 'inventoryStatus', label: 'Status', width: 15, type: 'status' },
      { key: 'calculatedStockOutDate', label: 'Stock Out Date', width: 20, type: 'date' }
    ],
    monthlyColumns: [
      { suffix: '_forecast', label: 'Forecast', width: 15, type: 'number' },
      { suffix: '_actual', label: 'Actual', width: 15, type: 'actualNumber' },
      { suffix: '_accuracy', label: 'Accuracy', width: 15, type: 'percentage' },
      { suffix: '_mtdSales', label: 'MTD Sales', width: 15, type: 'mtdSales', conditional: true },
      { suffix: '_upcoming', label: 'Upcoming', width: 15, type: 'number' }
    ],
    includesSummary: true
  }
};

export const EXPORT_NOTES = {
  category: [
    'This report shows forecast data grouped by category',
    'Month Cover calculated as: Current Stock / (3 months forecast)',
    'Status levels: New, Out of Stock, Shortage, Fast Moving, Ideal, Slow Moving, Excess'
  ],
  
  product: [
    'This report shows forecast data grouped by product',
    'Each product shows aggregated data across all SKUs',
    'Month Cover calculated as: Current Stock / (3 months forecast)',
    'Status reflects the overall product inventory level'
  ],
  
  sku: [
    'This report shows detailed forecast data for each SKU',
    'MTD Sales shown for current month only',
    'Stock Out Date calculated based on current consumption rate',
    'Summary sheet provides overview statistics by status',
    'Month Cover calculated as: Current Stock / (3 months forecast)'
  ]
};

// Value formatters for different data types
export const VALUE_FORMATTERS = {
  text: (value) => value || '-',
  number: (value) => value || 0,
  monthCover: (value) => {
    if (!value || value === 'NaN' || value === '0.00') return 'N/A';
    return value;
  },
  status: (value) => value?.label || '-',
  date: (value) => value || '-',
  actualNumber: (value) => value !== null ? value : '-',
  percentage: (value) => value !== null ? `${value}%` : '-',
  mtdSales: (value, month, item) => {
    // Only show MTD Sales for applicable months
    if (item[`${month}_mtdSales`] !== null && item[`${month}_mtdSales`] !== undefined) {
      return item[`${month}_mtdSales`];
    }
    return null; // Don't include this column for this month
  }
}; 
